import { render, staticRenderFns } from "./TicketScaleDataInfoAsChips.vue?vue&type=template&id=4e58c567&"
import script from "./TicketScaleDataInfoAsChips.vue?vue&type=script&lang=js&"
export * from "./TicketScaleDataInfoAsChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports